<template>
  <div
    class="c-color-picker"
    overlayClassName="c-color-picker"
    placement="right"
    :mouseLeaveDelay="1"
    :visible="colorPickerVivisble"
    arrowPointAtCenter
  >
    <div class="ant-tooltip-inner" slot="title">
      <sketch-picker
        :value="color"
        @input="onColorInput"
        disableAlpha
        :preset-colors="presetColors"
      />
      <i
        class="color-close iconfont iconclose-o"
        @click="colorPickerVivisble = false"
        v-if="false"
      />
    </div>
    <div
      class="color"
      :style="{ background: color }"
      @click="colorPickerVivisble = !colorPickerVivisble"
    ></div>
  </div>
</template>

<script>
import vueColor from "vue-color";

export default {
  name: "CColorPicker",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  model: {
    prop: "color", // 对应 props msg
    event: "input",
  },
  props: {
    color: String,
    presetColor: String,
  },
  data() {
    return {
      colorPickerVivisble: false,
      presetColors: window.presetColors || ["#8028f5"],
    };
  },
  computed: {},
  methods: {
    onColorInput(e) {
      let color = e.hex ? e.hex : "#" + e.target.value;
      color = color.length === 7 ? color : "#000000";
      this.$emit("input", color);
    },
    setRemovePresetColor() {
      setTimeout(() => {
        const colors = document.getElementsByClassName(
          "vc-sketch-presets-color"
        );
        for (let i = 0; i < colors.length; i++) {
          const remove = (e) => {
            e.stopPropagation();
            let color = e.target.getAttribute("aria-label");
            color = color ? color.replace("Color:", "") : "";
            const index = this.presetColors.indexOf(color);
            if (index !== -1) {
              this.presetColors.splice(index, 1);
              window.presetColors = this.presetColors;
            }
            return false;
          };
          colors[i].ondblclick = remove;
          colors[i].oncontextmenu = remove;
        }
      }, 500);
    },
  },
  watch: {
    presetColor(color) {
      if (color && !this.presetColors.includes(color)) {
        this.presetColors = [color, ...this.presetColors];
        window.presetColors = this.presetColors;
        this.setRemovePresetColor();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.colorPickerVivisble = true;
      this.setRemovePresetColor();
    }, 50);
  },
};
</script>

<style lang="scss">
.c-color-picker {
  max-width: none;
  z-index: 900;
  pointer-events: painted;
  position: relative;

  .ant-tooltip-arrow::before {
    background-color: transparent;
  }

  .ant-tooltip-inner {
    background-color: transparent;
    box-shadow: none;
    color: #000000;
    @include flex-center;
    flex-direction: column;
    padding: 0;

    .vc-sketch {
      background: #171717;
      border: 1px solid $primary-color;
      // transform: translateY(-100px);

      .vc-sketch-field {
        input {
          color: $primary-color;
          border: 1px solid $primary-color;
          box-shadow: none;
        }

        span {
          color: $primary-color;
        }
      }

      .vc-sketch-presets {
        border-color: $primary-color;
      }
    }

    .color-close {
      @include icon-hover;
      font-size: 40px;
      margin-top: 10px;
    }
  }

  .ant-tooltip-inner {
    position: absolute;
    left: 140%;
    top: -80px;
  }

  .color {
    position: relative;
    width: 0.46rem;
    height: 0.46rem;
    border-radius: 50%;
    border: 1px solid #8028f5;
  }
}

@media (max-width: 1400px) {
  .c-color-picker {
    .vc-sketch {
      // transform: translateY(-150px);
    }
  }
}
</style>
